import * as React from "react";

const Location: React.FC = () => {
    return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M4.5 9.49927C4.5 10.3363 4.66944 11.128 4.92214 11.881C6.00453 15.6664 8.71911 19.3435 12 23.4006C15.2816 19.3435 17.9955 15.6664 19.0779 11.881C19.3306 11.128 19.5 10.3363 19.5 9.49927C19.5 5.35743 16.1426 2 12 2C7.85744 2 4.5 5.35743 4.5 9.49927ZM8 9.49932C8 7.29063 9.79063 5.5 12 5.5C14.2094 5.5 16 7.29063 16 9.49932C16 11.7073 14.2094 13.498 12 13.498C9.79063 13.498 8 11.7073 8 9.49932Z" fill="currentColor"/>
    </svg>
    );
};

export default React.memo(Location);
